<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import type { MenuItem } from '~/types/menus'

const props = defineProps<{
  item: MenuItem
}>()

const attributes = computed(() => {
  const { isUsualLink, modalWindow, path } = props.item

  if (modalWindow) {
    return {}
  }

  if (path && isUsualLink) {
    return { href: path, rel: 'noopener noreferrer', target: '_blank' }
  }

  return { to: path }
})
const element = computed(() => {
  const { isUsualLink, modalWindow, path } = props.item

  if (modalWindow) {
    return 'div'
  }

  if (path && isUsualLink) {
    return 'a'
  }

  return defineNuxtLink({})
})

async function onClick (): Promise<void> {
  const { modalWindow, modalWindowProps } = props.item

  if (modalWindow) {
    await useModal({ component: modalWindow, attrs: modalWindowProps }).open()
  }
}
</script>

<template>
  <div>
    <component
      :is="element"
      class="
        box-border flex h-full cursor-pointer items-center rounded-xl border border-solid border-main-gray p-3 text-sm
        font-semibold text-main-green !no-underline transition-all duration-300
        ease-in-out hover:border-main-green hover:bg-main-green/10
        sm:p-4 sm:text-lg
      "
      v-bind="attributes"
      @click="onClick"
    >
      <SvgIcon v-if="item.icon" class="mr-2 !size-5 sm:mr-4 sm:!size-8" :name="item.icon" />

      <span>{{ item.name }}</span>
    </component>
  </div>
</template>
